import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';

import joinClasses from 'webapp/helpers/join-classes';

interface Args {
	type?: string;
	position?: 'left' | 'center' | 'right';
}

interface CommonSkeletonBarLoaderComponentInterface {
	Element: HTMLDivElement;
	Args: Args;
}

const SkeletonBarLoaderComponent: TOC<CommonSkeletonBarLoaderComponentInterface> = <template>
	<div
		class={{joinClasses
			(array
				"skeleton-bar-loader"
				(if @type (concat "skeleton-bar-loader--" @type))
				(if @position (concat "skeleton-bar-loader--" @position))
			)
		}}
	></div>
</template>;

export default SkeletonBarLoaderComponent;
